<div class="row" id="cmpName">

    <button (click)="back()" class="btn btn-primary">Atras</button>
    <div>
        <h3 style="float: center;">Nuevo Pedido</h3>
        <br>
        <form [formGroup]="registerForm" (ngSubmit)="imprimir(registerForm)">
            <h6><strong>Datos Cliente</strong></h6>
            <div class="row">
                <div class="form-group col-4">
                    <label for="inputState">Cliente</label>
                    <input readonly type="text" class="form-control" placeholder="Cliente" formControlName="customer">
                </div>
                <div class="form-group col-4">
                    <label for="inputState">Correo</label>
                    <input readonly type="text" class="form-control" placeholder="Correo" formControlName="email">
                </div>
                <div class="form-group col-4">
                    <label for="inputState">Telefono</label>
                    <input readonly type="text" class="form-control" placeholder="Telefono" formControlName="phone">
                </div>
            </div>
            <!-- COLORES -->
            <hr class="text-primary">
            <h6><strong>Modelo o Referencia</strong></h6>
            <div class="row">
                <div class="form-group col-6">
                    <label for="inputState">Referencia</label>
                    <input readonly type="text" class="form-control" placeholder="Modelo" formControlName="model">
                </div>
                <div class="form-group col-2"></div>
                <div class="form-group col-4">
                    <label for="inputState"><strong>Imagen de Referencia</strong></label><br>
                    <p>{{des}}</p>
                    <img style="max-width: 150px;" src="{{photo}}" alt="">
                </div>
            </div>


            <!-- COLORES -->
            <hr class="text-primary">
            <h6><strong>Colores</strong></h6>
            <div class="row">
                <div class="form-group col-4">
                    <label for="inputState">Color Principal</label>
                    <input readonly type="text" class="form-control" placeholder="Color Principal"
                        formControlName="colorpri">
                </div>
                <div class="form-group col-4">
                    <label for="inputState">Color Secundario</label>
                    <input readonly type="text" class="form-control" placeholder="Color Secundario"
                        formControlName="colorsec">
                </div>
                <div class="form-group col-4">
                    <label for="inputState">Color Terciario (opcional)</label>
                    <input readonly type="text" class="form-control" placeholder="Color Terciario"
                        formControlName="colorter">
                </div>
            </div>
            <!-- COLORES -->
            <hr class="text-primary">
            <h6><strong>Tallaje o Medidas</strong></h6>
            <div class="row">
                <div class="form-group col-12">
                    <label for="inputState">Tallaje o Medidas</label>
                    <input readonly type="text" class="form-control" placeholder="Modelo" formControlName="types">
                </div>

                <!--tallas-->
                <div *ngIf="tallas" class="row">
                    <div class="form-group col">
                        <label for="inputState">Tallas</label>
                        <input readonly type="text" class="form-control" placeholder="Modelo" formControlName="talla">
                    </div>
                    <div class="form-group col">
                        <label for="inputState">Cantidad</label>
                        <input readonly type="number" class="form-control" placeholder="Cantidad"
                            formControlName="cant">
                    </div>
                </div>
                <!--MEDIDAS-->
                <div *ngIf="medidas" class="row">
                    <div class="form-group col-6">
                        <label for="inputState">Hombro CM</label>
                        <input readonly type="number" class="form-control" placeholder="Hombro CM"
                            formControlName="hombro">
                    </div>
                    <div class="form-group col-6">
                        <label for="inputState">Brazo CM</label>
                        <input readonly type="number" class="form-control" placeholder="Brazo CM"
                            formControlName="brazo">
                    </div>
                    <div class="form-group col-6">
                        <label for="inputState">Pecho CM</label>
                        <input readonly type="number" class="form-control" placeholder="Pecho CM"
                            formControlName="pecho">
                    </div>
                    <div class="form-group col-6">
                        <label for="inputState">Contorno - Cintura CM</label>
                        <input readonly type="number" class="form-control" placeholder="Contorno - Cintura CM"
                            formControlName="contorno">
                    </div>
                    <div class="form-group col-6">
                        <label for="inputState">Largo Frente</label>
                        <input readonly type="number" class="form-control" placeholder="Largo Frente"
                            formControlName="largo">
                    </div>
                    <div class="form-group col-6">
                        <label for="inputState">Cadera - Damas</label>
                        <input readonly type="number" class="form-control" placeholder="Cadera Damas"
                            formControlName="cadera">
                    </div>
                    <div class="form-group col-6">
                        <label for="inputState">Cantidad</label>
                        <input readonly type="number" class="form-control" placeholder="Cantidad" formControlName="cant">
                    </div>
                </div>
            </div>


            <!-- LOGOS -->
            <hr class="text-primary">
            <h6><strong>Logos</strong></h6>
            <!--PERSONZIZADO-->
            <div class="form-group col">
                <label for="inputState"><strong>Logo o Diseño</strong></label>
                <input readonly type="text" class="form-control" placeholder="Logos" formControlName="logos">
                <!--select readonly id="inputState" class="form-control" formControlName="logos"
                    (change)="change2($event.target.value)">
                    <option value="" selected>Seleccione...</option>
                    <option value="Personalizado">Personalizado</option>
                    <option value="Alpinestar">Alpinestar</option>
                    <option value="Icon">Icon</option>
                    <option value="Fox">Fox</option>
                    <option value="KTM">KTM</option>
                    <option value="Kawasaki">Kawasaki</option>
                    <option value="Ducati">Ducati</option>
                    <option value="Monster">Monster</option>
                    <option value="Honda">Honda</option>
                    <option value="TVS">TVS</option>
                    <option value="AKT">AKT</option>
                    <option value="Dainese">Dainese</option>
                    <option value="Pulsar">Pulsar</option>
                    <option value="VR46">VR46</option>
                    <option value="Yamaha">Yamaha</option>
                    <option value="Suzuki">Suzuki</option>
                    <option value="Apache">Apache</option>
                </select>-->
            </div>
            <div *ngIf="verlogos">
                <div class="row">
                    <div class="form-group col-6">
                        <label for="inputState">Logo Jiba</label>
                        <select readonly id="inputState" class="form-control" formControlName="logojiba">
                            <option value="" selected>Seleccione...</option>
                            <option value="SI">SI</option>
                            <option value="NO">NO</option>
                        </select>
                    </div>
                    <div class="form-group col-6">
                        <label for="inputState">Adjuntar Imagen Jiba</label>
                        <img style="max-width: 10%;" src="{{logo1}}" alt="">
                        <input readonly (change)="uploadFile1($event)" type="file" class="form-control" placeholder="Adjunto"
                            formControlName="logojibaimagen">
                    </div>
                    <!---->
                    <div class="form-group col-6">
                        <label for="inputState">Logo Manga</label>
                        <select readonly id="inputState" class="form-control" formControlName="logomanga">
                            <option value="" selected>Seleccione...</option>
                            <option value="SI">SI</option>
                            <option value="NO">NO</option>
                        </select>
                    </div>
                    <div class="form-group col-6">
                        <label for="inputState">Adjuntar Imagen Manga</label>
                        <img style="max-width: 10%;" src="{{logo2}}" alt="">
                        <input readonly (change)="uploadFile2($event)" type="file" class="form-control" placeholder="Adjunto"
                            formControlName="logomangaimagen">
                    </div>
                    <!---->
                    <div class="form-group col-6">
                        <label for="inputState">Logo Frente</label>
                        <select readonly id="inputState" class="form-control" formControlName="logofrente">
                            <option value="" selected>Seleccione...</option>
                            <option value="SI">SI</option>
                            <option value="NO">NO</option>
                        </select>
                    </div>
                    <div class="form-group col-6">
                        <label for="inputState">Adjuntar Imagen Frente</label>
                        <img style="max-width: 10%;" src="{{logo3}}" alt="">
                        <input readonly (change)="uploadFile3($event)" type="file" class="form-control" placeholder="Adjunto"
                            formControlName="logofrenteimagen">
                    </div>
                    <!---->
                    <div class="form-group col-6">
                        <label for="inputState">Logo Espalda</label>
                        <select readonly id="inputState" class="form-control" formControlName="logoespalda">
                            <option value="" selected>Seleccione...</option>
                            <option value="SI">SI</option>
                            <option value="NO">NO</option>
                        </select>
                    </div>
                    <div class="form-group col-6">
                        <label for="inputState">Adjuntar Imagen Espalda</label>
                        <img style="max-width: 10%;" src="{{logo4}}" alt="">
                        <input readonly (change)="uploadFile4($event)" type="file" class="form-control" placeholder="Adjunto"
                            formControlName="logoespaldaimagen">
                    </div>

                    <!---->
                    <div class="form-group col-6">
                        <label for="inputState">Logo Pantalon</label>
                        <select readonly id="inputState" class="form-control" formControlName="logopantalon">
                            <option value="" selected>Seleccione...</option>
                            <option value="SI">SI</option>
                            <option value="NO">NO</option>
                        </select>
                    </div>
                    <div class="form-group col-6">
                        <label for="inputState">Adjuntar Imagen Pantalon</label>
                        <img style="max-width: 10%;" src="{{logo5}}" alt="">
                        <input readonly (change)="uploadFile5($event)" type="file" class="form-control" placeholder="Adjunto"
                            formControlName="logopantalonimagen">
                    </div>

                </div>
            </div>

            <div class="row">
                <!---->
                <div class="form-group col-4">
                    <label for="inputState">Logo RH</label>
                    <input readonly type="text" class="form-control" placeholder="Logo RH" formControlName="logorh">
                    <!--<select readonly id="inputState" class="form-control" formControlName="logorh">
                        <option value="" selected>Seleccione...</option>
                        <option value="SI">SI</option>
                        <option value="NO">NO</option>
                    </select>-->
                </div>
                <div class="form-group col-4">
                    <label for="inputState">Escribir RH</label>
                    <input readonly type="text" class="form-control" placeholder="RH" formControlName="logorhtext">
                </div>
                <div class="form-group col-4">
                    <label for="inputState">Ubicacion RH</label>
                    <input readonly type="text" class="form-control" placeholder="Ubicacion RH" formControlName="logorhlocation">
                    <!--<select readonly id="inputState" class="form-control" formControlName="logorhlocation">
                        <option value="" selected>Seleccione...</option>
                        <option value="Cuello">Cuello</option>
                        <option value="Frente">Frente</option>
                        <option value="Espalda">Espalda</option>
                        <option value="Manga">Manga</option>
                        <option value="Jiba">Jiba</option>
                    </select>-->
                </div>
                <!---->
                <div class="form-group col-4">
                    <label for="inputState">Logo Nombre</label>
                    <input readonly type="text" class="form-control" placeholder="Logo Nombre" formControlName="logonombre">
                    <!--<select readonly id="inputState" class="form-control" formControlName="logonombre">
                        <option value="" selected>Seleccione...</option>
                        <option value="SI">SI</option>
                        <option value="NO">NO</option>
                    </select>-->
                </div>
                <div class="form-group col-4">
                    <label for="inputState">Escribir Nombre</label>
                    <input readonly type="text" class="form-control" placeholder="Nombre" formControlName="logonombretext">
                </div>
                <div class="form-group col-4">
                    <label for="inputState">Ubicacion Nombre</label>
                    <input readonly type="text" class="form-control" placeholder="Ubicacion Nombre" formControlName="logonombrelocation">
                    <!--<select readonly id="inputState" class="form-control" formControlName="logonombrelocation">
                        <option value="" selected>Seleccione...</option>
                        <option value="Cuello">Cuello</option>
                        <option value="Frente">Frente</option>
                        <option value="Espalda">Espalda</option>
                        <option value="Manga">Manga</option>
                        <option value="Jiba">Jiba</option>
                    </select>-->
                </div>
            </div>



            <!-- COLORES -->
            <hr class="text-primary">
            <h6><strong>Adicionales</strong></h6>
            <div class="row">
                <label for="inputState">Observaciones o Comentarios</label>
                <textarea readonly type="text" class="form-control" placeholder="Observaciones"
                    formControlName="observations"></textarea>
            </div>

            <!--GUARDAR-->
            <hr class="text-primary">
            <h6><strong>IMPRIMIR PDF</strong></h6>
            <div class="row">
                <label for="inputState">POR FAVOR REVISAR Y CONFIRMAR</label>
                <button type="submit" class="btn btn-primary">IMPRIMIR</button>
            </div>
            <br>
        </form>
    </div>



</div>